import { parseAbi } from 'viem';

/** Experimental wire format only; not a runtime pin or permission to enable orders. */
export const experimentalExternalFixedRouteModuleId = 'test-only.external-fixed-route-order.1' as const;
/** Same order calldata; distinct runtime identity for validation slot 2. */
export const experimentalExternalCoexistenceModuleId = 'test-only.external-fixed-route-order.2' as const;
export const knownExperimentalExternalModuleIds = [
  experimentalExternalFixedRouteModuleId,
  experimentalExternalCoexistenceModuleId,
] as const;

/** Identification only. Exact runtime/profile admission is still required. */
export function isKnownExperimentalExternalModuleId(value: unknown): boolean {
  return knownExperimentalExternalModuleIds.some(moduleId => moduleId === value);
}
export const experimentalExternalFixedRouteOrderAbi = parseAbi([
  'struct Pin { address account; bytes32 codeHash; }',
  'struct Asset { address account; bytes32 codeHash; uint8 decimals; }',
  'struct Route { uint8 family; Pin router; Pin permit2; Pin factory; bytes32 poolInitCodeHash; Asset[] tokens; Pin[] pools; uint24[] fees; }',
  'struct ProfileInput { Route route; address feeRecipient; uint16 feeBps; }',
  'struct Profile { Route route; bytes32 routeIdentityHash; address feeRecipient; uint16 feeBps; }',
  'struct Context { uint256 globalEpoch; uint256 routeRevision; }',
  'struct Trigger { uint256 numerator; uint256 denominator; bool atOrBelow; bool latchAfterFirstFill; }',
  'struct Leg { uint128 minimumTotalNetOutput; uint256 expiry; Trigger trigger; }',
  'struct Order { uint256 globalEpoch; bytes32 routeId; uint256 routeRevision; address owner; bool buy; uint128 maximumInput; uint128 minimumTotalNetOutput; uint256 expiry; bool cancelled; bool filled; uint128 cumulativeInput; uint256 cumulativeNetOutput; uint256 fillRevision; }',
  'function vault() view returns(address)',
  'function keeper() view returns(address)',
  'function reader() view returns(address)',
  'function callBuilder() view returns(address)',
  'function globalEpoch() view returns(uint256)',
  'function epoch() view returns(uint256)',
  'function armed() view returns(bool)',
  'function healthy() view returns(bool)',
  'function nextOrder() view returns(uint256)',
  'function moduleId() pure returns(string)',
  'function arm()',
  'function armInitialSetup()',
  'function configureRoute(ProfileInput input) returns(bytes32 routeId)',
  'function disableRoute(bytes32 routeId)',
  'function routeStates(bytes32 routeId) view returns(uint256 revision,bool enabled)',
  'function routeProfile(bytes32 routeId,uint256 revision) view returns(Profile)',
  'function order(uint256 id) view returns(Order)',
  'function triggers(uint256 id) view returns(uint256 numerator,uint256 denominator,bool atOrBelow,bool latchAfterFirstFill)',
  'function allocationPeer(uint256 id) view returns(uint256)',
  'function allocationRemaining(uint256 id) view returns(uint128)',
  'function register(bytes32 routeId,Context expected,bool buy,uint128 maximumInput,uint128 minimumTotalNetOutput,uint256 expiry,Trigger trigger) returns(uint256 id)',
  'function registerAllocation(bytes32 routeId,Context expected,uint128 maximumInput,Leg first,Leg second) returns(uint256 firstId,uint256 secondId)',
  'function cancel(uint256 id)',
  'function fill(uint256 id,uint128 maximumThisFill,uint256 expectedRevision)',
  'function callsFor(uint256 id,uint128 maximumThisFill) view returns(bytes)',
  'function checkTrigger(uint256 id,uint256 revision)',
  'event RouteConfigured(bytes32 indexed routeId,uint256 indexed revision,bytes32 routeIdentityHash,address feeRecipient,uint16 feeBps)',
  'event RouteDisabled(bytes32 indexed routeId,uint256 indexed revision)',
  'event Registered(uint256 indexed id,bytes32 indexed routeId,uint256 routeRevision,uint256 globalEpoch,bool buy,uint128 input,uint128 minimumNetOutput)',
  'event Cancelled(uint256 indexed id)',
  'event Filled(uint256 indexed id,uint256 revision,uint128 actualInput,uint256 actualNetOutput,uint128 cumulativeInput,uint256 cumulativeNetOutput,bool complete)',
  'error Denied()', 'error Unhealthy()', 'error InvalidRoute()', 'error InvalidOrder()',
  'error TriggerNotMet()', 'error BalanceBound()',
]);
